











































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import { Prop, Watch } from 'vue-property-decorator'
import CopyableText from '@/modules/shared/components/shared/CopyableText.vue'

const irAmount = require('iramount')

@Component({
  components: { CopyableText, CurrencyInput }
})
export default class WidgetTomanConverter extends Vue {
  @Prop({ default: false }) dark!: boolean
  inputCurrency: number = 0
  iramount = new irAmount(this.inputCurrency)

  @Watch('inputCurrency')
  onCurrencyChange(value) {
    this.iramount.amount = (value) ? (value * 10) : 0
  }

  get outputStyle() {
    return {
      backgroundColor: (this.dark) ? '#485a83' : '#EFF1F7',
      borderRadius: '8px'
    }
  }

  get inputFa() {
    return this.iramount.farsiFormatToman()
  }

  get outputFa(): string {
    return this.iramount.farsiFormatRial()
  }

  get output() {
    return this.iramount.digitGrouped('R', 'Fa').split('.')[0]
  }

  get enDigit() {
    return Number(this.iramount.digitGrouped('R', 'En').replace(',', ''))
  }
}

